import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';

const el = document.getElementById('root');
if (!el) throw new Error('Root element missing from index.html');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
